const { DateTime } = require('luxon');
const DataHora = ({ value }) => {
    if (!value) return null;
    const dateTime = new Date(value);
    return DateTime.fromJSDate(dateTime, {
        zone: 'America/Sao_Paulo',
    }).toFormat('dd/MM/yyyy - HH:mm');
};

export default DataHora;
